import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { supabase } from "@/integrations/supabase/client";
import { Loader2 } from "lucide-react";
import { rememberReturnPath } from "@/lib/sessionHealth";

export const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  const [mustChange, setMustChange] = useState<boolean | null>(null);

  useEffect(() => {
    let cancelled = false;
    if (!user) { setMustChange(null); return; }
    supabase.from("profiles").select("must_change_password").eq("id", user.id).maybeSingle().then(({ data }) => {
      if (!cancelled) setMustChange(!!data?.must_change_password);
    });
    return () => { cancelled = true; };
  }, [user]);

  if (loading || (user && mustChange === null)) {
    return (
      <div className="flex h-screen items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }
  if (!user) {
    // Keep the page the user was on, so an unexpected session loss does not
    // drop them back at the dashboard after signing in again.
    rememberReturnPath(location.pathname + location.search);
    return <Navigate to="/auth" replace />;
  }
  if (mustChange && location.pathname !== "/change-password") {
    return <Navigate to="/change-password" replace />;
  }
  return <>{children}</>;
};
